
import FinAgentMessagesContainer from '@/components/finagent/FinAgentMessagesContainer';
import FinAgentQuestionLeftCard from "@/components/finagent/FinAgentQuestionLeftCard";
import FinAgentStockMenuCard from '@/components/finagent/FinAgentStockMenuCard';
import { finAgentMenuType, messageCreator } from "@/constants/finAgent";
import subscriptionConstants from '@/constants/subscription.constants';

const { subscribeProductKeys, subscriptionPlans } = subscriptionConstants;

export default {
    name: 'MarketAnalysisFAQDialog',

    components: {
        FinAgentMessagesContainer,
        FinAgentStockMenuCard,
        FinAgentQuestionLeftCard,
    },
    
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        faqData: {
            type: Object,
            default: () => {},
        },
    },

    emits: ['input'],

    data() {
        return {
            messages: [],
            isLoadingFaqAnswer: false,
            stockCardInterval: this.$store.getters["preferences/getMarketAnalysisChartInterval"],
            menuState: {
                visible: false,
                x: 0,
                y: 0,
                type: null,
                data: {}
            },
        };
    },

    computed: {
        infoIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/info-filled-dark.svg') :
                require('@/assets/icons/info-filled-light.svg');
        },
        isLoggedIn() {
            return !!this.$store.state.account.user;
        },
        isSubscribedFinAgent() {
            return this.isLoggedIn && this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
        isFreePlan() {
            return this.isLoggedIn && !this.isSubscribedFinAgent;
        },
        isReachFreePlanLimit() {
            return this.$store.state.finAgent.isReachFreePlanLimit;
        },
        showFreeQuestionLeftCard() {
            if (!this.isFreePlan) {
                return false;
            }

            if (this.$store.state.finAgent.isLoadingQuestionUsage) {
                return false;
            }

            return !this.isReachFreePlanLimit && this.$vuetify.breakpoint.mdAndUp;
        },
        disabledAskFinAgent() {
            return this.isFreePlan && this.isReachFreePlanLimit;
        },
        showFooter() {
            return this.isLoggedIn && (this.isSubscribedFinAgent || !this.isReachFreePlanLimit);
        }
    },

    watch: {
        faqData(data) {
            if (!data.id || !data.question) {
                this.messages = [];
                return;
            }
            const faqQuestion = {
                message: data.question,
                creator: messageCreator.user,
                widgets: [],
                created: new Date().toISOString(),
                id: `faq-question-${new Date().toISOString()}`,
            };
            this.messages = [faqQuestion];            
            this.fetchFaqAnswer(data.id);
        },
        value(state) {
            if (!state) {
                this.reset();
            }
        }
    },

    beforeDestroy() {
        this.reset();
    },

    created() {
        this.finAgentMenuType = finAgentMenuType;
    },

    methods: {
        closeModal() {
            this.$emit('input', false);
        },
        reset() {
            this.messages = [];
            this.$store.commit('finAgent/resetFinAgentState',
                { preserveProperties: ['questionUsage', 'isReachFreePlanLimit', 'preservedQuestion', 'wishListIsins'] }
            );
            this.cancelActiveRequest();
            this.isLoadingFaqAnswer = false;
            this.resetMenuState();
        },
        cancelActiveRequest() {
            if (this.activeRequest) {
                this.activeRequest.cancel()
            }
        },
        handleClickAskFinAgent() {
            if (this.disabledAskFinAgent) {
                this.$router.push({
                    name: this.$getTranslatedRouteName('subscription'),
                    params: { plan: subscriptionPlans.ai }
                })
            }
        },
        getFinAgentLink() {
            if (this.disabledAskFinAgent) {
                return '';
            }

            if (this.$store.state.finAgent.currentThread.id) {
                return this.$getTranslatedRoutePath(`/fin-agent/thread/${this.$store.state.finAgent.currentThread.id}/`);
            }

            return this.$getTranslatedRoutePath('/fin-agent/');
        },
        async fetchFaqAnswer(id) {
            if (!id) {
                return;
            }

            try {
                this.isLoadingFaqAnswer = true;
                const url = `/api/faq/${id}`;
                const axiosSource = this.$axios.CancelToken.source();
                const cancelToken = axiosSource.token;
                this.activeRequest = { cancel: axiosSource.cancel, msg: "Cancel loading faq answer..." };   
                const res = await this.$axios.get(url, { cancelToken });
                if (res.data && res.data.answer) {
                    const faqMessage = {
                        message: res.data.answer,
                        creator: messageCreator.agent,
                        widgets: [],
                        created: new Date().toISOString(),
                        id: `faq-message-${new Date().toISOString()}`,
                        suggestedFollowUpQueries: res.data.suggestedFollowUpQuestions ?? []
                    };

                    this.messages.push(faqMessage);
                }
                this.isLoadingFaqAnswer = false;
                this.activeRequest = null;
            } catch (error) {
                this.isLoadingFaqAnswer = false;
            }
        },
        handleClickSuggestQuestion() {
            if (this.disabledAskFinAgent) {
                this.$router.push({
                    name: this.$getTranslatedRouteName('subscription'),
                    params: { plan: subscriptionPlans.ai }
                })
            }
        },
        handleUpdateMenuState(state) {
            if (this.menuState.visible) {
                return;
            }
            this.menuState = { ...this.menuState, ...state };
        },
        resetMenuState() {
            this.menuState.visible = false;
            this.menuState.type = null;
            this.menuState.data = {};
        },
    },

}
